export default __webpack_public_path__ + "static/media/albufeira66pic2.5f8395b9.jpg";